import React, { Component } from "react";
import Select from "react-select";

// Components
import Loader from "../../../utils/Loader";
import PhoneField from "../../../utils/PhoneField";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

class ChiefExecFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = [
			"chief_exec_salutation",
			"chief_exec_fname",
			"chief_exec_lname",
			"chief_exec_title",
			"chief_exec_email",
			"chief_exec_phone",
			"chief_exec_phone_extension"
		];
		this.miscProps = [
			"errors",
			"salutationsError",
			"salutationsLoading",
			"salutations",
			"inProcess"
		];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const {
			data,
			errors,
			salutationsError,
			salutationsLoading,
			salutations,
			inProcess
		} = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Chief Executive</div>
				
				<div className="fieldset-indent">
					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Chief Executive First Name:</label>

							{!!errors.chief_exec_fname && (
								<ErrorWrap animate={1}>{errors.chief_exec_fname}</ErrorWrap>
							)}
							<input
								type="text"
								id="chief_exec_fname"
								value={data.chief_exec_fname}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>

						<div className="form-field half-field">
							<label>Chief Executive Last Name:</label>

							{!!errors.chief_exec_lname && (
								<ErrorWrap animate={1}>{errors.chief_exec_lname}</ErrorWrap>
							)}
							<input
								type="text"
								id="chief_exec_lname"
								value={data.chief_exec_lname}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Chief Executive Title:</label>

							{!!errors.chief_exec_title && (
								<ErrorWrap animate={1}>{errors.chief_exec_title}</ErrorWrap>
							)}
							<input
								type="text"
								id="chief_exec_title"
								value={data.chief_exec_title}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
						<div className="form-field half-field">
							<label>Chief Executive Email</label>

							{!!errors.chief_exec_email && (
								<ErrorWrap animate={1}>{errors.chief_exec_email}</ErrorWrap>
							)}
							<input
								type="email"
								id="chief_exec_email"
								value={data.chief_exec_email}
								// maxLength="20"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>

					<div className="floated-field-container">
						<PhoneField
							label={"Chief Executive Phone"}
							phone_name="chief_exec_phone"
							ext_name="chief_exec_phone_extension"
							phone={data.chief_exec_phone}
							extension={data.chief_exec_phone_extension}
							errorPhone={errors.chief_exec_phone}
							errorExtension={errors.chief_exec_phone_extension}
							inProcess={inProcess}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
						/>

						<div className="form-field half-field">
							<label htmlFor="province">Chief Executive Salutation:</label>

							{salutationsError ? (
								<ErrorWrap>{salutationsError}</ErrorWrap>
							) : salutationsLoading ? (
								<Loader />
							) : (
										<React.Fragment>
											{!!errors.salutation && (
												<ErrorWrap animate={1}>{errors.salutation}</ErrorWrap>
											)}

											<Select
												classNamePrefix="react-select"
												placeholder={"Select one"}
												isClearable={false}
												isDisabled={inProcess}
												name={`chief_exec_salutation`}
												value={salutations.filter(
													({ id }) => id === data.chief_exec_salutation
												)}
												onChange={({ id }) => {
													this.props.updateSelectedValue(id, "chief_exec_salutation");
												}}
												options={salutations}
												getOptionLabel={({ id }) => id}
												getOptionValue={({ id }) => id}
											/>
										</React.Fragment>
									)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ChiefExecFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/ChiefExecFieldset.js